// extracted by mini-css-extract-plugin
module.exports = {"selectedValue":"useTestSection_selectedValue__z9ZWu","selectedName":"useTestSection_selectedName__VDF_M","dropdownTime":"useTestSection_dropdownTime__E_jFv"};